module.exports = __webpack_public_path__ + "static/media/menu-burger.1263a88f.svg";